import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from 'antd';
import MarketingLayout from './MarketingLayout';
import { listPublicAnnouncements } from '../../services/content';
import { ContentItem } from '../../types/content';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';

const AnnouncementsListPage: React.FC = () => {
  const [rows, setRows] = useState<ContentItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await listPublicAnnouncements({ page, page_size: pageSize });
        setRows(data.results || []);
        setTotal(data.count || 0);
      } catch {
        setRows([]);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [page, pageSize]);

  useDocumentMeta({ title: '公告', description: '安飞供应链系统公告列表' });

  return (
    <MarketingLayout>
      <section className="mx-auto max-w-6xl px-6 py-14">
        <h1 className="text-2xl font-normal text-gray-900">公告</h1>
        <p className="mt-3 text-sm leading-7 text-gray-600">查看所有已发布的近期公告信息。</p>
      </section>

      <section className="mx-auto max-w-6xl px-6 pb-20">
        <div className="rounded-xl border border-[#d9eaff] bg-white p-5 shadow-sm">
          {loading ? (
            <div className="py-10 text-center text-sm text-gray-500">加载中...</div>
          ) : rows.length ? (
            <div className="space-y-3">
              {rows.map((item) => {
                const displayTime = (item.published_at || item.created_at || '').replace('T', ' ').slice(0, 19);
                return (
                  <div key={item.id} className="rounded border border-gray-100 px-4 py-3">
                    <div className="flex flex-col gap-1 md:flex-row md:items-center md:justify-between">
                      <Link
                        to={`/announcements/${item.id}`}
                        className="text-base font-medium text-[#2f82e8] hover:text-[#1d6fcc] hover:underline"
                      >
                        {item.title}
                      </Link>
                      <span className="text-xs text-gray-500">{displayTime || '-'}</span>
                    </div>
                    {item.summary ? <p className="mt-1 text-sm text-gray-600">{item.summary}</p> : null}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="py-10 text-center text-sm text-gray-500">暂无公告</div>
          )}

          {total > 0 ? (
            <div className="mt-6 flex justify-end">
              <Pagination
                current={page}
                pageSize={pageSize}
                total={total}
                showSizeChanger
                showQuickJumper
                showTotal={(all, range) => `第${range[0]}-${range[1]}条 共${all}条记录`}
                onChange={(p, ps) => {
                  setPage(p);
                  setPageSize(ps);
                }}
              />
            </div>
          ) : null}
        </div>
      </section>
    </MarketingLayout>
  );
};

export default AnnouncementsListPage;
